import React, { useEffect, useState } from "react";
import { debounce } from "lodash";
import { TextField } from "@mui/material";
import type { SxProps } from "@mui/material";

interface DebouncedInputProps {
  initialValue?: string;
  onDebouncedUpdate: (val: string) => void;
  className?: string;
  sx?: SxProps;
  placeholder?: string;
  minRows?: number;
  maxRows?: number;
}

const DebouncedInput: React.FC<DebouncedInputProps> = ({
  initialValue = "",
  onDebouncedUpdate,
  className,
  sx,
  placeholder = "Enter text...",
  minRows = 6,
  maxRows = 10,
}) => {
  const [value, setValue] = useState(initialValue);

  const debouncedUpdate = React.useRef(
    debounce((val: string) => {
      onDebouncedUpdate(val);
    }, 300)
  ).current;

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const val = e.target.value;
    setValue(val);
    debouncedUpdate(val);
  };

  if (className) {
    return (
      <textarea
        className={className}
        value={value}
        onChange={handleChange}
        rows={21}
        placeholder={placeholder}
      />
    );
  }

  return (
    <TextField
      value={value}
      onChange={handleChange}
      fullWidth
      multiline
      minRows={minRows}
      maxRows={maxRows}
      placeholder={placeholder}
      sx={sx}
    />
  );
};

export default DebouncedInput;
